<style lang="less" scoped>
  @import "../../vars.less";
  .button-container {
    padding: @space-normal;
    background-color: #fff;
  }
  .property-item:not(:first-child) {
    margin-top: @space-medium;
  }
</style>

<style lang="less">
  @import "../../vars.less";
  .disabled-label {
    color: @text-color-secondary;
  }
</style>

<template>
  <page-container :title="$route.query.Name" :loading="loading || applyLoading">
    <van-tabs v-model="active" color="#009999" title-active-color="#009999"
      animated border
      line-height="2px" line-width="30%">
      <van-tab :title="$t('基本信息')" :name="TAB_NAMES.BASE" :disabled="!$auth('LookBaseCustomer')">
        <van-form label-align="right">
          <van-field :value="baseInfo.Code" readonly :label="$t('SI客户编码')" />
          <van-field :value="baseInfo.Status" readonly :label="$t('状态')" />
          <van-field :value="baseInfo.USCCode" readonly :label="$t('统一信用代码')" />
          <van-field rows="1" autosize type="textarea"
            v-model="baseInfo.Name" readonly
            :label="$t('客户中文名称')" />
          <van-field rows="1" autosize type="textarea"
            v-model="baseInfo.EnName" readonly
            :label="$t('客户英文名称')" />
          <van-field rows="1" autosize type="textarea"
            v-model="baseInfo.Address" readonly
            :label="$t('地址')" />
          <van-field :value="baseInfo.CountryName" readonly :label="$t('国家/地区')" />
          <van-field :value="baseInfo.ProvinceName" readonly :label="$t('省份')" />
          <van-field :value="baseInfo.CityName" readonly :label="$t('城市')" />
          <van-field :value="baseInfo.ZoneName" readonly :label="$t('区县')" />
          <van-field :value="baseInfo.PostCode" readonly :label="$t('邮编')" />
          <van-field :value="baseInfo.SecretTypeName" readonly :label="$t('企业涉密类型')" />
          <van-field :value="baseInfo.SAPNo" readonly :label="$t('SAP号(Sold To)')" />
          <van-field :value="baseInfo.EndUserCode" readonly :label="$t('SAP号(End User)')" />
          <van-field :value="baseInfo.IFA" readonly :label="$t('IFA')" />
          <van-field :value="baseInfo.SieSalesID" readonly :label="$t('SieSalesID')" />
          <van-field :value="baseInfo.CreatorUserName" readonly :label="$t('申请人')" />
          <van-field :value="baseInfo.CreateDate" readonly :label="$t('申请时间')" />
        </van-form>
      </van-tab>
      <van-tab :name="TAB_NAMES.PROPERTY" :title="$t('属性信息')" :disabled="!$auth('SICustomerPropertyLook')">
        <div class="property-item" v-for="(p, i) of propertyInfo" :key="i">
          <van-form label-align="right">
            <van-field :value="p.BUName" readonly :label="$t('BU')" />
            <van-field :value="p.AccountRoleName" readonly :label="$t('属性')" />
            <van-field :value="p.RegionName" readonly :label="$t('区域')" />
            <van-field :value="p.OfficeName" readonly :label="$t('办事处')" />
            <van-field :value="p.CreateDate" readonly :label="$t('记录时间')" />
            <van-field :value="p.Status" readonly :label="$t('状态')" />
            <template v-if="p.PlateFactory">
              <van-field rows="1" autosize type="textarea"
                :value="p.PlateFactory.Name" disabled :label="$t('盘厂名称')" />
              <van-field :value="p.PlateFactory.DutySalerName" disabled :label="$t('负责该盘厂的SI销售')" />
              <van-field rows="1" autosize type="textarea"
               :value="p.PlateFactory.SalePropertyName" disabled :label="$t('销售属性')" />
              <van-field :value="p.PlateFactory.DutySalerPhone" disabled :label="$t('销售联系方式')" />
              <van-field :value="p.PlateFactory.DutySalerEmail" disabled :label="$t('销售邮箱地址')" />
              <van-field :value="p.PlateFactory.TSSName" disabled :label="$t('BU TSS 负责人')" />
              <van-field :value="p.PlateFactory.TSSPhone" disabled :label="$t('TSS联系方式')" />
              <van-field :value="p.PlateFactory.TSSEmail" disabled :label="$t('TSS邮箱地址')" />
            </template>
          </van-form>
        </div>
        <!--
          if there's no other element in van-tab and only an v-for tag
          it will not render anything!!
          holy fuck!!
          this may be a bug of van-tab
        -->
        <div></div>
        <van-dialog v-model="applyDialogShow" confirm-button-color="#009999"
          :title="$t('选择客户角色')"
          show-cancel-button :get-container="getContainer"
          :before-close="beforeClose">
          <picker v-model="applyForm.BUCode" :label="$t('BU')"
            value-field="Code" text-field="Name"
            :columns="BUs"/>
          <picker v-model="applyForm.AccountRoleCode" :label="$t('属性')"
            value-field="Code" text-field="Name"
            :columns="avaliableAccountRoles"/>
          <van-field :value="regionName" disabled :label="$t('区域')">
            <van-loading v-if="rAoLoading" slot="right-icon" size="24px" />
          </van-field>
          <van-field :value="officeName" disabled :label="$t('办事处')">
            <van-loading v-if="rAoLoading" slot="right-icon" size="24px" />
          </van-field>
        </van-dialog>
      </van-tab>
      <van-tab :name="TAB_NAMES.DISTRIBUTOR" :title="$t('分销商')" :disabled="!$auth('SICustomerDisLook')">
        <van-form label-align="right" class="extra-form">
          <van-field :value="distributorInfo.BUName" readonly :label="$t('BU')" />
          <van-field rows="1" autosize type="textarea"
            :value="distributorInfo.DisFullName" readonly :label="$t('分销商名称')" />
          <van-field :value="distributorInfo.StatusName" readonly :label="$t('状态')" />
        </van-form>
      </van-tab>
    </van-tabs>
    <div v-if="propertyApplyAvailiable" class="button-container" slot="footer">
      <van-button round block type="info" size="small" @click="startApply">{{ $t('申请客户角色') }}</van-button>
    </div>
  </page-container>
</template>

<script>
import PageContainer from '../../components/PageContainer'
import Picker from '../../components/Picker'
import { Field, Tabs, Tab, Form, Button, Dialog, Notify, Loading } from 'vant'
import { LS_KEYS } from '../../constants'
import ls from '../../utils/local-storage'

const TAB_NAMES = {
  BASE: 'base-info',
  PROPERTY: 'property-info',
  DISTRIBUTOR: 'distributor-info'
}

export default {
  name: 'customer-detail',
  components: {
    PageContainer,
    picker: Picker,
    'van-field': Field,
    'van-tabs': Tabs,
    'van-tab': Tab,
    'van-form': Form,
    'van-button': Button,
    'van-dialog': Dialog.Component,
    'van-loading': Loading
  },
  data () {
    return {
      TAB_NAMES,
      active: TAB_NAMES.BASE,
      loading: false,
      baseInfoFetched: false,
      baseInfo: {
        Code: '',
        Status: '',
        USCCode: '',
        Name: '',
        EnName: '',
        Address: '',
        CountryName: '',
        ProvinceName: '',
        CityName: '',
        ZoneName: '',
        PostCode: '',
        SecretTypeName: '',
        SAPNo: '',
        EndUserCode: '',
        IFA: '',
        SieSalesID: '',
        CreatorUserName: '',
        CreateDate: ''
        // 申请人
        // 申请时间

      },
      propertyInfoFetched: false,
      propertyInfo: [
        // {
        //   BUName: '',
        //   BUCode: '',
        //   AccountRoleName: '',
        //   AccountRoleCode: '',
        //   RegionName: '',
        //   RegionCode: '',
        //   OfficeName: '',
        //   OfficeCode: '',
        //   CreateDate: '',
        //   CreatorUserName: '',
        //   Status: '',
        //   PlateFactory: {}
        // }
      ],
      distributorInfoFetched: false,
      distributorInfo: {
        BUName: '',
        DisFullName: '',
        StatusName: ''
      },
      applyForm: {
        BUCode: 'LP',
        AccountRoleCode: 'ME',
        RegionCode: '',
        OfficeCode: ''
      },
      applyDialogShow: false,
      applyLoading: false,
      BUs: [],
      accountRoles: [],
      rAoLoading: false,
      regions: [],
      offices: []
    }
  },
  computed: {
    propertyApplyAvailiable () {
      return this.$auth('SIPropertyRequest') &&
        this.active === TAB_NAMES.PROPERTY &&
        this.propertyInfo.length < this.accountRoles.length
    },
    regionName () {
      const region = this.regions.find(item => item.Code === this.applyForm.RegionCode)
      return region ? region.Name : ''
    },
    officeName () {
      const office = this.offices.find(item => item.Code === this.applyForm.OfficeCode)
      return office ? office.Name : ''
    },
    avaliableAccountRoles () {
      const currentBuExistedProperties = this.propertyInfo
        .filter(item => item.BUCode === this.applyForm.BUCode)
        .map(item => item.AccountRoleCode)
      return this.accountRoles.filter(ar => !currentBuExistedProperties.includes(ar.Code))
    }
  },
  watch: {
    active (v) {
      if (v === TAB_NAMES.BASE) {
        this.getBaseInfo()
      }
      if (v === TAB_NAMES.PROPERTY) {
        this.getPropertyInfo()
      }
      if (v === TAB_NAMES.DISTRIBUTOR) {
        this.getDistributorInfo()
      }
    },
    'applyForm.BUCode' (v) {
      this.getRegionAndOfficeByBU(v)
    },
    avaliableAccountRoles (v) {
      if (v && v.length) {
        this.applyForm.AccountRoleCode = v[0].Code
      }
    }
  },
  methods: {
    getContainer () { return document.body },
    getBaseInfo () {
      if (this.baseInfoFetched) return
      this.$apis.customer.getBaseInfo(
        this.$route.query.Pkey,
        loading => (this.loading = loading)
      ).then(res => {
        if (!res) return
        this.baseInfoFetched = true
        this.baseInfo = res
      })
    },
    getPropertyInfo () {
      if (this.propertyInfoFetched) return
      this.$apis.customer.getPropertyInfo(
        this.$route.query.Code,
        loading => (this.loading = loading)
      ).then(res => {
        if (!res) return
        this.propertyInfoFetched = true
        this.propertyInfo = res
      })
    },
    getDistributorInfo () {
      if (this.distributorInfoFetched) return
      this.$apis.customer.getDistributorInfo(
        this.$route.query.Pkey,
        loading => (this.loading = loading)
      ).then(res => {
        if (!res) return
        this.distributorInfoFetched = true
        res[0] && (this.distributorInfo = res[0])
      })
    },
    startApply () {
      this.applyDialogShow = true
      this.getBUs()
      this.getRegionAndOfficeByBU()
    },
    getBUs () {
      this.$apis.basic.getCustomerBUs(
        loading => (this.applyLoading = loading)
      ).then(res => {
        this.BUs = res
      })
    },
    getAccountRoles () {
      this.$apis.basic.getCustomerAccountRoles(
        loading => (this.applyLoading = loading)
      ).then(res => {
        if (res && res.filter) {
          // remove this property by project manager QiaoLi
          this.accountRoles = res.filter(item => item.Code !== 'Distributor')
        }
      })
    },
    getRegionAndOfficeByBU () {
      this.$apis.customer.getRegionAndOfficeByBU(
        this.$route.query.Pkey,
        this.applyForm.BUCode,
        loading => (this.rAoLoading = loading)
      ).then(res => {
        if (res) this.applyForm.RegionCode = res.RegionCode
        if (res) this.applyForm.OfficeCode = res.OfficeCode
      })
    },
    getRegions () {
      this.$apis.basic.getCustomerRegions(() => {}).then(res => {
        if (!res) return
        this.regions = res
      })
    },
    getOffices () {
      this.$apis.basic.getCustomerOffices(() => {}).then(res => {
        if (!res) return
        this.offices = res
      })
    },
    createProperty () {
      const userinfo = ls.get(LS_KEYS.USERINFO)
      if (!userinfo) return

      return this.$apis.customer.createProperty({
        ...this.applyForm,
        CustomerID: this.$route.query.Pkey,
        // CreateDate: this.propertyInfo.CreateDate,
        Creator: userinfo.account,
        CreatorUserName: userinfo.name
      }, () => {}).then(res => {
        if (!res) return
        Notify({
          type: 'success',
          message: this.$t('属性申请成功')
        })
        return res
      })
    },
    beforeClose (action, done) {
      if (action === 'cancel') done()
      else {
        for (const p of this.propertyInfo) {
          if (p.BUCode === this.applyForm.BUCode && p.AccountRoleCode === this.applyForm.AccountRoleCode) {
            Notify({
              type: 'warning',
              message: this.$t('此BU下此属性已经存在')
            })
            done()
            return
          }
        }

        this.createProperty().then(res => {
          if (res) {
            done()
            this.propertyInfoFetched = false
            this.getPropertyInfo()
          } else done(false)
        })
      }
    }
  },
  mounted () {
    this.getBaseInfo()
    this.getRegions()
    this.getOffices()
    this.getAccountRoles()
  }
}
</script>
